import { render } from "./WrappedNFRs.vue?vue&type=template&id=941feb90"
import script from "./WrappedNFRs.vue?vue&type=script&lang=js"
export * from "./WrappedNFRs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__